import { Grid } from "@mui/material";
import { Container } from "@mui/system";
import { useState } from "react";
import vitaleauImage from "../assets/images/VitalEau-Lieu-5.jpg";
import MetaMaster from "../components/utils/MetaMaster";
import { HeroInner } from "../stories/organisms/HeroInner";

export default function ConditionsGenerales() {
    const [arianeItem] = useState([
        ["/", "Vital'Eau"],
        ["/conditions-generales", "Conditions Générales d’Abonnement"],
    ]);

    return (
        <>
            <MetaMaster title="Vital’Eau - Conditions Générales d’Abonnement" />
            <HeroInner arianeItem={arianeItem} imagesSwiper={[vitaleauImage]} />

            <section className="section-show-pool-home section-legales" id="accueil-histoire">
                <Container maxWidth="lg">
                    <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div>
                                <h1
                                    className="accueil-histoire-titre h1-inner"
                                    data-title="Conditions Générales d’Abonnement"
                                >
                                    Conditions Générales d’Abonnement
                                </h1>
                                <p id="accueil-histoire-baseline"></p>
                            </div>
                        </Grid>

                        <Grid item lg={10} md={10} sm={12} xs={12}>
                            <div className="bloc_info_mentions">
                                <h2>Extrait des Conditions Générales d’Abonnement</h2>
                                <p><strong>(CGA complètes à l’entrée de la piscine)</strong></p>

                                <p>
                                    <strong>1 - </strong>
                                    Les adhérents sont tenus de prendre connaissance des CGA affichées à l’entrée de l’établissement. Ces CGA peuvent être modifiées par la direction à tout moment en fonction des intérêts de Vital’Eau et de ses adhérents.
                                </p>

                                <p>
                                    <strong>2 - </strong>
                                    La signature du présent contrat d’adhésion engage irrévocablement l’adhérent(e) et la souscription portera sur l’une des prestations proposées par Vital’Eau.
                                </p>

                                <p>
                                    <strong>3 - </strong>
                                    Sont compris dans la durée de l’abonnement les congés et fermetures justifiés par l’entretien et la réparation du matériel et des locaux.
                                </p>

                                <p>
                                    <strong>4 - </strong>
                                    Une séance manquée du fait de l’adhérent(e) ne sera ni remboursée, ni remplacée.
                                </p>

                                <p>
                                    <strong>5 - </strong>
                                    Aucune cause de résiliation n’est admise, exception faite des cas de force majeure, et sur justificatif LÉGAL ET OFFICIEL dûment communiqué par courrier recommandé à la direction de l’établissement dans un délai maximum de 15 jours à compter du fait justificatif, ce dont l’adhérent reconnaît être parfaitement informé.
                                </p>

                                <p>
                                    <strong>6 - </strong>
                                    Par souci de sécurité, nous refusons l’accès à l’AquaTonic et à l’AquaTraining aux femmes enceintes. Dans le cas où la pratiquante serait enceinte et n’aurait pas informé la direction et/ou le personnel de son état, Vital’Eau se décharge de toute responsabilité quant aux répercussions que pourrait entraîner la pratique de l’AquaTonic et de l’AquaTraining sur sa grossesse.
                                </p>

                                <p>
                                    <strong>7 - </strong>
                                    Les parents ou représentants légaux des adhérents mineurs sont tenus de veiller à la présence des enfants aux activités. Ils doivent donc prendre en charge leurs enfants avant le début et à la fin de chaque séance. Les enfants de plus de 13 ans sur décharge des parents ne sont pas soumis à cet article.
                                </p>
                                <p>
                                    La responsabilité de Vital’Eau n’est effective que dans l’enceinte de la piscine aux stricts horaires de pratique.
                                </p>

                                <p>
                                    <strong>8 - </strong>
                                    Lors des séances de natation enfants : la présence d’un seul accompagnateur adulte par enfant dans l’eau est autorisée à l’étage.
                                </p>

                                <p>
                                    <strong>9 - </strong>
                                    Pour des raisons d’hygiène, de sécurité et conformément au règlement de l’établissement, seuls les maillots de bain traditionnels sont autorisés dans les bassins. Le port du burkini ainsi que de tout autre vêtement de bain couvrant similaire n’est pas autorisé.
                                </p>
                                <p>
                                    Si vous souhaitez pratiquer la natation avec ce type de tenue, nous pouvons, sur demande, vous communiquer les coordonnées d’une association proposant des créneaux de baignade durant lesquels ce type de tenue est autorisé.
                                </p>

                                <h2>Il est strictement obligatoire de :</h2>
                                <ul>
                                    <li>respecter les zones de circulation pieds chaussés (accueil) et pieds nus (vestiaires, douches, sanitaires, plage, bassin, étage),</li>
                                    <li>prendre une douche avant d’entrer sur la plage du bassin,</li>
                                    <li>se conformer aux recommandations émises par le personnel de Vital’Eau,</li>
                                    <li>être en possession, pour des mesures d’hygiène, d’une serviette.</li>
                                </ul>

                                <h2>Il est strictement interdit de :</h2>
                                <ul>
                                    <li>laisser les enfants de moins de 13 ans sans surveillance des parents ou représentants légaux à l’étage,</li>
                                    <li>courir dans l’établissement,</li>
                                    <li>marcher chaussé et manger dans les zones pieds nus (douches, sanitaires, plages, étage),</li>
                                    <li>fumer, cracher, mâcher du chewing-gum,</li>
                                    <li>faire usage de la cigarette électronique dans l’établissement,</li>
                                    <li>troubler l’ordre et la tranquillité par des actes ou comportements non conformes aux règles de civilité,</li>
                                    <li>faire usage du téléphone portable dans l’établissement,</li>
                                    <li>détériorer le bâtiment ou ses installations,</li>
                                    <li>faire un affichage dans les locaux ou aux extérieurs sans l’accord de la direction.</li>
                                </ul>

                                <p>
                                    Je certifie souscrire un abonnement à la Piscine Vital’Eau et je déclare avoir pris connaissance de cet extrait et des CGA affichées à l’entrée de l’établissement, et m’y conformer en totalité. Abonnement non transférable et non remboursable. Toute somme versée est considérée comme due et ne peut être remboursée, même au cas où l’abonnement ne serait pas suivi d’effet.
                                </p>
                                <p>
                                    Je déclare que ma constitution physique et mon état de santé OU ceux de mon enfant me/lui permettent de participer aux cours de Vital’Eau.
                                </p>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
        </>
    );
}
